import { isHoliday } from '~/astra'
import { components } from '~/clients/optimus-api-types.generated'
import { useActivePractitioners, useLocations, usePractitionerStatusDefinitions } from '~/storm'

import { MinimalPreviewPractitionerScheduleLocation, MinimalPreviewPractitionerScheduleStatus } from './types'

type ApplyPreviewData = {
    statuses: MinimalPreviewPractitionerScheduleStatus[]
    locations: MinimalPreviewPractitionerScheduleLocation[]
}

export function useApplyPreviewData(data?: components['schemas']['RecurringAssignmentSchedule']): ApplyPreviewData {
    const activePractitioners = new Map(useActivePractitioners({ selectedSpecialties: 'all' }).map(p => [p.uuid, p]))
    const definitions = usePractitionerStatusDefinitions({ keyBy: 'code' })
    const locationsByRoomCode = useLocations({ keyBy: 'room_code' })
    const statuses: MinimalPreviewPractitionerScheduleStatus[] = []
    const locations: MinimalPreviewPractitionerScheduleLocation[] = []
    const createdBy = '[Forhåndsvisning]'
    const timestamp = new Date().toISOString()

    for (const assignment of data?.assignments ?? []) {
        const practitioner = activePractitioners.get(assignment.practitioner_uuid)
        if (!practitioner || isHoliday(assignment.date)) continue

        for (const code of assignment.status_codes ?? []) {
            const definition = definitions.get(code)
            if (!definition) continue
            statuses.push({
                id: undefined,
                practitionerId: practitioner.id,
                date: assignment.date,
                definition: {
                    code: definition.code,
                    label: definition.label,
                    color: definition.color,
                    title: undefined,
                },
                updated_by: createdBy,
                updated_at: timestamp,
            })
        }
        for (const roomCode of assignment.room_codes ?? []) {
            const location = locationsByRoomCode.get(roomCode)
            if (!location) continue
            locations.push({
                id: undefined,
                practitionerId: practitioner.id,
                date: assignment.date,
                location: {
                    id: location.id,
                    uuid: location.uuid,
                    room_code: location.room_code,
                },
                updated_by: createdBy,
                updated_at: timestamp,
            })
        }
    }

    return { statuses, locations }
}
